module.exports = "https://cdn.realtymogul.com/static/media/img_card_locked.615ab17a.jpg";